import React from "react"
import DocsPlastics from "../environment/en/DocsPlastics"
import RequiredDocs from "../environment/en/RequiredDocs"
import DocsDisposal from "../environment/en/RequiredDocs"

const Documents = props => {
  if (props.type === "plastics") {
    return <RequiredDocs service_id={1} />
  } else if (props.type === "disposal") {
    return <RequiredDocs service_id={2} />
  } else if (props.type === "export") {
    return <RequiredDocs service_id={3} />
  } else if (props.type === "import") {
    return <RequiredDocs service_id={4} />
  } else if (props.type === "delivery-partner") {
    return <RequiredDocs service_id={6} />
  } else if (props.type === "accreditation") {
    return <RequiredDocs service_id={17001} />
  } else if (props.type === "no-objection") {
    return <RequiredDocs service_id={17002} />
  } else if (props.type === "environmental-audit") {
    return <RequiredDocs service_id={17003} />
  } else {
    return <></>
  }
}

export default Documents
